document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('article-product-card-style')) {
    const style = document.createElement('style');
    style.id = 'article-product-card-style';
    style.textContent = `
      [data-article-product-card] a {
        text-decoration: none !important;
        background: none !important;
        padding-bottom: 0 !important;
      }
      [data-article-product-card] .card,
      [data-article-product-card] .card--product {
        border: none !important;
        box-shadow: none !important;
        overflow: hidden !important;
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll('[data-article-product-card]').forEach(async (el) => {
    const handle = el.dataset.handle?.replace(/[""„"'']/g, '').trim();
    if (!handle) return;
    try {
      const res = await fetch(`/products/${handle}?view=article-card`);
      if (!res.ok) throw new Error(`Produkt "${handle}" nicht gefunden`);
      const html = await res.text();
      const temp = document.createElement('div');
      temp.innerHTML = html;

      temp.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
        if (link.href && !document.querySelector(`link[href="${link.href}"]`)) {
          document.head.appendChild(link.cloneNode(true));
        }
      });

      const card = temp.querySelector('.card-wrapper');
      if (!card) throw new Error('Karte nicht im Response gefunden');
      el.innerHTML = '';
      el.appendChild(card);
    } catch (err) {
      console.error('Produktkarte konnte nicht geladen werden:', err);
      el.remove();
    }
  });
});